module.exports = __webpack_public_path__ + "static/FiraCode-Light-8c574ce84d5db50582b71f028e3c08b4.woff2";